import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ApplicationModel } from '../../model';
import { Retrieve } from '@core/data-access';

export type SetApplicationProps = {
  application: ApplicationModel;
};

export type SetCorpPassCodeProps = {
  corppassCode: string;
};

export type SetRetrieveProps = {
  retrieve: Retrieve;
};

export type SetAccessTokenProps = {
  accessToken: string;
};

export const ApplicationActions = createActionGroup({
  source: 'Application',
  events: {
    Init: emptyProps(),
    'Set Access Token': props<SetAccessTokenProps>(),
    'Set Application': props<SetApplicationProps>(),
    'Set CorpPass Code': props<SetCorpPassCodeProps>(),
    'Set Retrieve': props<SetRetrieveProps>(),
  },
});
